import { IClientExtraData } from 'src/layouts/common/Dashboard';

export const clientExtraDataInitValue:IClientExtraData = {
  selectedAll: true
};
